export default __webpack_public_path__ + "img/shape-closed-arc.6d348cc6.svg";